exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.municipio { position: relative; z-index: 10; cursor: pointer;\n}\na.title { cursor: pointer;\n}\n.card-e-1 {\n    max-width: 1200px;\n    margin: 0 auto;\n    display: grid;\n    grid-gap: 1rem;\n    grid-template-columns: repeat(4, 1fr);\n}\n.card-e-2{\n    background-color: #FFF;\n    color: #4A4A4A;\n    height: 23.25rem;\n    width: 16.25rem;\n}\n.card-e-2-img { height: 16.25rem; width: 100%; margin: 0;\n}\n.card-e-2-constainer { height: 7rem; padding: 2rem 0;\n}\n@supports(object-fit: cover){\n.card-e-2-img  img{\n    height: 100%;\n    object-fit: cover;\n    object-position: center center;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-271e4300","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/Que_hacemos.vue
// module id = a0f4
// module chunks = 0